import React from 'react';
import { Link } from 'react-router-dom';
import MarketingShell from '../../components/MarketingShell';

export default function ProductLandingPage({ title, description, bullets, ctaTo, ctaLabel }) {
  return (
    <MarketingShell title={title} description={description}>
      <div className="rounded-xl border border-gray-100 bg-white p-6">
        <ul className="space-y-2 text-sm text-gray-600">
          {bullets.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
        <Link
          to={ctaTo}
          className="mt-6 inline-flex items-center rounded-lg bg-gray-900 px-4 py-2 text-sm font-medium text-white hover:bg-gray-800 transition-colors"
        >
          {ctaLabel}
        </Link>
      </div>
    </MarketingShell>
  );
}
